module.exports = __webpack_public_path__ + "997bf25dfdbd7d4fab14b91b293fa6f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2112_teaser_image.jpg
// module id = 605
// module chunks = 0